<template>
  <NavigationComponent>
    <Standardfolie title="Binding">
      <p>In Vue lassen sich Attribute einfach dynamisch an Elemente binden:</p>
      <VCode :content="this.insertCode"></VCode>
      <v-row
        ><v-spacer></v-spacer>
        <v-btn :color="btnColor" @click="onClick">{{ this.btnText }}</v-btn
        ><v-spacer></v-spacer
      ></v-row>
    </Standardfolie>
  </NavigationComponent>
</template>

<script>
import NavigationComponent from "@/components/NavigationComponent";
import Standardfolie from "@/components/Standardfolie";
import VCode from "@/components/VCode";

export default {
  name: "Binding",
  components: { Standardfolie, NavigationComponent, VCode },

  data: function() {
    return {
      btnState: false,
      insertCode:
        '<v-btn :color="btnColor" @click="onClick"> \n{{ this.btnText }}</v-btn>'
    };
  },
  methods: {
    onClick() {
      this.btnState = !this.btnState;
    }
  },
  computed: {
    btnColor() {
      if (this.btnState) {
        return "red";
      } else {
        return "blue";
      }
    },
    btnText() {
      if (this.btnState) {
        return "Clicked";
      } else {
        return "Click me";
      }
    }
  }
};
</script>

<style scoped></style>
